import { Skeleton } from '@flintmint/web-shared/components/skeleton';

// Loading placeholders shared by the AI usage and user details pages; each page passes its own CSS module so the
// placeholder takes that page's layout. Kept free of chart code so the route skeleton can show them.

export function MetricCardsSkeleton({ count, testId, styles }: { count: number; testId: string; styles: CSSModuleClasses }) {
  return (
    <section className={styles.metricGrid}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={styles.metric} data-testid={testId}>
          <Skeleton width={110} height={12} />
          <Skeleton width={90} height={25} />
        </div>
      ))}
    </section>
  );
}

export function UsageChartSkeleton({ height, styles }: { height: number; styles: CSSModuleClasses }) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Monthly Cost By Model</h3>
      </div>
      <div className={styles.chartFrame} data-testid="usage-chart-skeleton">
        <Skeleton width="100%" height={height} />
      </div>
    </section>
  );
}
